import React                       from 'react';
import PropTypes                   from 'prop-types';
import Flux                        from '../../../flux/Flux';
import {scrollToElem}              from '../../../utils/CommonUtils';
import AlbumDescriptionButtons     from './AlbumDescriptionButtons';
import AlbumDescriptionDetails     from './AlbumDescriptionDetails';
import AlbumDescriptionSocialShare from './AlbumDescriptionSocialShare';


class AlbumDescription extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			socialShareVisible: false,
		};

		this.onShareClick    = this.onShareClick.bind(this);
		this.onCommentsClick = this.onCommentsClick.bind(this);
	}

	onShareClick() {
		this.setState({socialShareVisible: !this.state.socialShareVisible});
	}

	onCommentsClick() {
		scrollToElem('pjax-scrollto-comments', true);
		Flux.Gallery.focusCommentsInput();
	}

	render() {
		const {actor, album, baseClassName, showSocialShare} = this.props;
		const {socialShareVisible}                           = this.state;

		return (
			album && <div>
				<div className={baseClassName + '-text'} dangerouslySetInnerHTML={{__html: album.description}} />

				<div className={baseClassName + '-complex-wrapper'}>
					<AlbumDescriptionDetails baseClassName={baseClassName + '-complex'}
					                         actorName={actor.name}
					                         contestPlace={album.contestPlace}
					                         contestDetailsUrl={album.contestDetailsUrl}
					                         releaseDate={album.releaseDate}
					                         duration={album.duration}
					                         hasAudio={album.hasAudio}
					                         totalViews={album.totalViews}
					/>

					<div className={baseClassName + '-complex-share'}>
						<AlbumDescriptionButtons baseClassName={baseClassName + '-complex-share__actions'}
						                         actor={actor}
						                         album={album}
						                         onShareClick={this.onShareClick}
						                         onCommentsClick={this.onCommentsClick}
						                         showSocialShare={showSocialShare}
						/>
					</div>

					{showSocialShare &&
					<AlbumDescriptionSocialShare baseClassName={baseClassName + '-complex-share-contents'}
					                             isVisible={socialShareVisible}
					                             album={album}
					/>}
				</div>
			</div>
		);
	}
}

AlbumDescription.propTypes = {
	baseClassName:   PropTypes.string,
	showSocialShare: PropTypes.bool,
	album:           PropTypes.shape({
		id:                 PropTypes.number,
		description:        PropTypes.string,
		contestPlace:       PropTypes.number,
		releaseDate:        PropTypes.string,
		duration:           PropTypes.string,
		hasAudio:           PropTypes.bool,
		totalViews:         PropTypes.number,
		title:              PropTypes.string,
		contestDetailsUrl:  PropTypes.string,
		likes:              PropTypes.number,
		dislikes:           PropTypes.number,
		isLiked:            PropTypes.bool,
		isDisliked:         PropTypes.bool,
		isFavorite:         PropTypes.bool,
		isVotingVisible:    PropTypes.bool,
		areCommentsVisible: PropTypes.bool,
	}),
	actor:           PropTypes.shape({
		id:   PropTypes.number,
		name: PropTypes.string,
	}),
};

AlbumDescription.defaultProps = {
	baseClassName:   'profile-video-details--description',
	showSocialShare: true,
};

export default AlbumDescription;
